import { useLanguage } from "../App";
import { motion } from "framer-motion";
import { Button } from "./ui/button";
import { Cookie, X, Settings } from "lucide-react";

export const CookieBanner = ({ onAccept, onReject }) => {
  const { t } = useLanguage();

  return (
    <motion.div
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      exit={{ y: 100, opacity: 0 }}
      className="fixed bottom-0 left-0 right-0 bg-slate-900 text-white z-50 shadow-2xl"
      data-testid="cookie-banner"
    >
      <div className="max-w-7xl mx-auto px-4 py-4">
        <div className="flex flex-col md:flex-row items-center justify-between gap-4">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-amber-500 rounded-lg">
              <Cookie size={20} className="text-white" />
            </div>
            <p className="text-sm text-slate-300">
              {t.cookie.message}
            </p>
          </div>

          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="sm"
              onClick={onReject}
              className="text-slate-400 hover:text-white"
              data-testid="cookie-reject"
            >
              <X size={16} className="mr-1" />
              {t.cookie.reject}
            </Button>
            <Button
              variant="outline"
              size="sm"
              className="border-slate-600 text-slate-300 hover:bg-slate-800"
              data-testid="cookie-settings"
            >
              <Settings size={16} className="mr-1" />
              {t.cookie.settings}
            </Button>
            <Button
              size="sm"
              onClick={onAccept}
              className="bg-blue-600 hover:bg-blue-700"
              data-testid="cookie-accept"
            >
              {t.cookie.accept}
            </Button>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default CookieBanner;
